import React from 'react';
import c from 'classnames';

import './DrawerLink.scss';

type DrawerLink$Props = {
  url: string;
  children: React.ReactNode;
  className?: string;
};

export default function DrawerLink(props: DrawerLink$Props) {
  const { url, className, ...rest } = props;
  const CN = c('drawerLink', className);

  return (
    <a href={url} className={CN} {...rest}>
      {props.children}
    </a>
  );
}
